"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var defaultTranslations = {
  birch: {
    dropdowns: {
      no_results: 'No results found',
      create_item: 'Create',
      error_loading_results: 'There was an error loading results',
      condensed_chip_text: function condensed_chip_text(unitName, numSelectedItems) {
        return "".concat(unitName, " (").concat(numSelectedItems, ")");
      }
    },
    top_navigation: {
      more_items: 'More',
      search: 'Search',
      cancel: 'Cancel',
      clear: 'Clear',
      application_switcher: {
        dropdown_label: 'Switch applications'
      }
    }
  }
};
var TranslationsContext = /*#__PURE__*/React.createContext(defaultTranslations);
var _default = TranslationsContext;
exports["default"] = _default;